import { http } from '../../../../api/http';
import type {
  GuiaSalida,
  GuiaSalidaRequest,
  StockDisponibleItem,
} from '../types';

export class GuiaSalidaService {
  private static readonly BASE_URL = '/produccion/guiasalida';

  static async getAll(): Promise<GuiaSalida[]> {
    try {
      const response = await http.get(`${this.BASE_URL}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching guias de salida:', error);
      throw error;
    }
  }

  static async getByEstado(estado: string): Promise<GuiaSalida[]> {
    try {
      const response = await http.get(`${this.BASE_URL}/estado/${estado}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching guias de salida por estado ${estado}:`, error);
      throw error;
    }
  }

  static async getById(id: number): Promise<GuiaSalida> {
    try {
      const response = await http.get(`${this.BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching guia de salida ${id}:`, error);
      throw error;
    }
  }

  static async getStockDisponible(excludeGuiaSalidaId?: number): Promise<StockDisponibleItem[]> {
    try {
      const url = excludeGuiaSalidaId != null
        ? `${this.BASE_URL}/stock-disponible?excludeGuiaSalidaId=${excludeGuiaSalidaId}`
        : `${this.BASE_URL}/stock-disponible`;
      const response = await http.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching stock disponible:', error);
      throw error;
    }
  }

  static async create(request: GuiaSalidaRequest): Promise<GuiaSalida> {
    try {
      const response = await http.post(`${this.BASE_URL}`, request);
      return response.data;
    } catch (error) {
      console.error('Error creando guia de salida:', error);
      throw error;
    }
  }

  static async update(id: number, request: GuiaSalidaRequest): Promise<GuiaSalida> {
    try {
      const response = await http.put(`${this.BASE_URL}/${id}`, request);
      return response.data;
    } catch (error) {
      console.error(`Error actualizando guia de salida ${id}:`, error);
      throw error;
    }
  }

  static async updateEstado(id: number, estado: string): Promise<void> {
    try {
      await http.put(`${this.BASE_URL}/${id}/estado/${estado}`);
    } catch (error) {
      console.error(`Error actualizando estado de guia de salida ${id}:`, error);
      throw error;
    }
  }

  static async delete(id: number): Promise<void> {
    try {
      await http.delete(`${this.BASE_URL}/${id}`);
    } catch (error) {
      console.error(`Error eliminando guia de salida ${id}:`, error);
      throw error;
    }
  }
}
